import { render } from "./rrss-shared.vue?vue&type=template&id=628b9226&scoped=true&lang=html"
import script from "./rrss-shared.vue?vue&type=script&lang=js"
export * from "./rrss-shared.vue?vue&type=script&lang=js"

import "./rrss-shared.vue?vue&type=style&index=0&id=628b9226&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628b9226"]])

export default __exports__